import { forwardRef } from 'react';
import styles from './SkillCard.module.css';

interface SkillCardProps {
  title: string;
  skills: string[];
}

const SkillCard = forwardRef<HTMLDivElement, SkillCardProps>(({ title, skills }, ref) => {
  return (
    <div className={styles.skillCard} ref={ref}>
      <h3 className={styles.cardTitle}>{title}</h3>
      <ul className={styles.list}>
        {skills.map((skill, index) => (
          <li key={index} className={styles.listItem}>
            {skill}
          </li>
        ))}
      </ul>
    </div>
  );
});

SkillCard.displayName = 'SkillCard';

export default SkillCard;

